module.exports = __webpack_public_path__ + "VAGRoundedStd-Thin.c84b38ec17ce653f5d82.otf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.otf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.otf
// module chunks = styles